import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NodesUpdatedSubscriptionVariables = Types.Exact<{
  hierarchyIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
  nodeIds: Array<Types.Scalars['String']> | Types.Scalars['String'];
  username?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type NodesUpdatedSubscription = { nodesUpdated: { hierarchyId: string, nodeId: string, type: Types.NodeUpdateType, author?: string | null, timestamp: number, edits: Array<{ contentTypeGroupIndex: number, contentTypeGroup: string, contentType: string, value: any, type: string }> } };


export const NodesUpdatedDocument = gql`
    subscription NodesUpdated($hierarchyIds: [String!]!, $nodeIds: [String!]!, $username: String) {
  nodesUpdated(
    hierarchyIds: $hierarchyIds
    nodeIds: $nodeIds
    username: $username
  ) {
    hierarchyId
    nodeId
    type
    author
    timestamp
    edits {
      contentTypeGroupIndex
      contentTypeGroup
      contentType
      value
      type
    }
  }
}
    `;

/**
 * __useNodesUpdatedSubscription__
 *
 * To run a query within a React component, call `useNodesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNodesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodesUpdatedSubscription({
 *   variables: {
 *      hierarchyIds: // value for 'hierarchyIds'
 *      nodeIds: // value for 'nodeIds'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useNodesUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<NodesUpdatedSubscription, NodesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NodesUpdatedSubscription, NodesUpdatedSubscriptionVariables>(NodesUpdatedDocument, options);
      }
export type NodesUpdatedSubscriptionHookResult = ReturnType<typeof useNodesUpdatedSubscription>;
export type NodesUpdatedSubscriptionResult = Apollo.SubscriptionResult<NodesUpdatedSubscription>;